export function parseBucketCoords(bucket) {
  if (bucket === undefined || bucket === null) return { x: null, y: null };
  const parts = String(bucket).split("_");
  return { x: parts[0] ?? null, y: parts[1] ?? null };
}

export function padHeatmapGrid(data = [], n) {
  if (!Number.isInteger(n) || n < 1) return data;

  const xLabels = Array.from({ length: n }, (_, i) => String(i));
  const yLabels = Array.from({ length: n }, (_, i) => String(i));
  const base = [];
  const indexMap = new Map();

  for (const y of yLabels) {
    for (const x of xLabels) {
      const k = `${x}__${y}`;
      indexMap.set(k, base.length);
      base.push({ key: x, group: y, value: 0 });
    }
  }

  (Array.isArray(data) ? data : [data]).forEach(d => {
    if (!d) return;
    const k = `${String(d.key ?? '')}__${String(d.group ?? '')}`;
    if (indexMap.has(k)) {
      base[indexMap.get(k)] = { ...base[indexMap.get(k)], value: Number(d.value ?? 0) };
    } else {
      base.push({ key: String(d.key ?? ''), group: String(d.group ?? ''), value: Number(d.value ?? 0) });
    }
  });

  return base;
}

export function transformHeatmapData(panelData, effectiveCamera, cameraFilter, chart) {
  if (!panelData || !Array.isArray(panelData) || panelData.length === 0) return [];

  let filtered = panelData;
  const camCol = cameraFilter?.column;
  if (camCol && effectiveCamera && panelData[0] && camCol in panelData[0]) {
    filtered = panelData.filter(r => r?.[camCol] === effectiveCamera);
  }

  const [xAgg, yAgg] = String(chart.aggregate_by || '')
    .split(/[;,]/)
    .map(s => s.trim());
  const xKey = xAgg || chart.x_column_name || 'quadrant_camera_x';
  const yKey = yAgg || 'quadrant_camera_y';
  const metricKeyCandidates = ['value', 'mean', 'avg', 'count', 'total', 'sum', 'qty', 'n'];
  const firstRow = filtered[0] || {};
  const detectedMetricKey = metricKeyCandidates.find(k => k in firstRow) || 'count';

  let normalized = filtered.map(r => {
    if (!r) return { key: '', group: '', value: 0 };
    let x, y;
    if (r.bucket !== undefined && r.bucket !== null) {
      const { x: bx, y: by } = parseBucketCoords(r.bucket);
      x = bx; y = by;
    } else {
      x = r?.[xKey]; y = r?.[yKey];
    }
    return {
      key: String(x ?? ''),
      group: String(y ?? ''),
      value: Number(r?.[detectedMetricKey] ?? 0),
    };
  });

  const n = Number(chart.heatmap_grid_size);
  if (Number.isInteger(n) && n > 0) {
    normalized = padHeatmapGrid(normalized, n);
  }

  return normalized;
}